import { environment } from '../../environments/environment';

declare var require: any;

export const URL_BASE = `${environment.backendUrl}/shipment_tracking_rest`;
export const WEBHOOK_URL_BASE = `${environment.webhookBackendUrl}/webhooks`;
export const SERVICE_DESK_URL_BASE = `${environment.serviceDeskUrl}`;
export const DEDICATED_FLEET_URL_BASE = `${environment.backendDedicatedFMUrl}`;

const { version: appVersion } = require('../../../package.json');
export const APP_VERSION      = appVersion;
export const ENV      = environment.env;
export const ANALYTICS_CONFIGURATION           = environment.analyticsConfiguration;

export const LOCAL_STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  ID_TOKEN: 'id_token',
  PROFILE: 'profile',
  LOCAL_LOADS_FILTERS: 'local-loads.search.filters',
  LOCAL_LOADS_CARRIER: 'local-loads.search.carrier',
  WEBHOOK_EVENTS_CARRIER: 'webhook-events.carrier',
  REORDER_LOADS_CARRIER: 'local-loads.reorder.carrier',
  REORDER_LOADS_VEHICLE: 'local-loads.reorder.vehicle.filters',
  REORDER_LOADS_SEARCH: 'local-loads.reorder.search.filters',
  MANUAL_LOCAL_LOADS_CARRIER: 'local-loads.manual.carrier',
  MANUAL_LOCAL_LOADS_VEHICLE: 'local-loads.manual.vehicle',
  LOG_EVENTS_COLUMNS: 'log-events.columns.filters',
  FORCED_CHECKIN_REGION: 'forced-checkin.filters.region',
  FORCED_CHECKIN_CARRIER: 'forced-checkin.filters.carrier',
  HOTSPOT_MAP_REGION: 'hotspot.map.region',
  LOCALE: 'locale',
  OVERDUE_SEARCH_MODE: 'overdue.filters.search-mode'
};
